import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateNotesShift", function updateNotesShift(notes: string) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.notes = notes;
    }
});